import { render } from "./CoachDetail.vue?vue&type=template&id=bb1f6b86&scoped=true"
import script from "./CoachDetail.vue?vue&type=script&lang=js"
export * from "./CoachDetail.vue?vue&type=script&lang=js"

import "./CoachDetail.vue?vue&type=style&index=0&id=bb1f6b86&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-bb1f6b86"

export default script